export default __webpack_public_path__ + "static/media/logo_admin.ae6fd581.svg";